<template>
  <div class="po-r w100 bg-w card-shadow">
    <el-row class="w100 bor-b card-title">
      <el-col class="pl20" :span="18">
        <p class="font-16 blue">服务大厅</p>
      </el-col>
    </el-row>

    <div class="pt10 pb10 pl20 pr20">
      <div class="w100 mb10 cu-p img-view" :style="{ 'background-image': `url(${baseUrl}images/home-banner.png)` }" @click="goServe()"></div>
      <p class="grey mb5">我们为您准备了<span class="ml5 mr5 orange">{{ serveNum ? serveNum : '-' }}</span>个校园服务</p>
      <p class="grey mb5">目前已为我校师生服务<span class="ml5 mr5 blue">{{ officeNum ? officeNum : '-' }}</span>次</p>
    </div>
  </div>
</template>

<script>
export default {
  name: "CardAppOffice",
  props: {},
  data() {
    return {
      baseUrl: process.env.BASE_URL,

      serveNum: null,
      officeNum: null
    };
  },
  computed: {},
  mounted() {
    this.fetchNum();
  },
  methods: {
    fetchNum() {
      this.$http
        .post("serve/getServeInfo")
        .then(({ data }) => {
          // console.log(data);
          if (data.resCode == "0") {
            this.serveNum = parseFloat(data.resData.list[0]).toLocaleString();
            this.officeNum = parseFloat(data.resData.list[1]).toLocaleString();
          }
        })
        .catch(() => {});
    },
    goServe() {
      this.$router.push({
        name: "serve"
      });
    }
  }
};
</script>

<style scoped>
.img-view {
  height: 200px;
  background: center center no-repeat;
  background-size: cover;
}
</style>
